<template>
  <v-row justify="center">
    <v-dialog v-model="pdfDialog" min-width="500px" max-width="900px" persistent>
      <v-card class="dialog-padding">
        <v-card-title class="d-flex justify-space-between align-center pa-4">
          <span class="dialog-title">{{$t('__downloadPreview')}}</span>
          <v-btn icon @click="pdfDialog = false"><v-icon size="30" color="#9E9E9E">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text style="height: 60vh;">
          <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="100%" style="border:none"></iframe>
        </v-card-text>
          <v-btn class="colorBtn primary-color-background ml-3" outlined color="#FFF" @click="downloadPdf">
            {{$t('__downloadBtn')}}
          </v-btn>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  components: {},
  name:'PdfDownload',
  props:[],
  data () {
    return {
      active: false,
      onSaveEn: false,
      id: '',
      page: '',

      pdfDialog: false,
      pdfUrl: '',
      pdfBlob: null,
    }
  },
  watch:{
    pdfDialog(val) {
      if (!val && this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl)
        this.pdfUrl = ''
        this.pdfBlob = null
      }
    }
  },
  methods:{
    open(id, page , caseId, onSaveEn = false){
      this.active = true
      
      this.id = id
      this.page = page
      this.caseId = caseId
      this.exportPdf(this.id, this.caseId)
      this.onSaveEn = onSaveEn
    },
    close(){
      this.active = false
    },
    save(){
      if(this.onSaveEn){
        this.onSave()
      }
      this.close()
    },
    exportPdf(id, caseId) {
      var self = this
      var request = {
        method: 'GET',
        url: (self.page == 'assignment') ? '/ExportServiceReportPdf' :  (self.page == 'history') ? '/ExportClosedServiceReportPdf' :'',
        params: { id: id, caseId: caseId },
        responseType: 'blob',
      }
      this.$http(request).then(function(response) {
        // 存 blob
        self.pdfBlob = new Blob([response.data], { type: 'application/pdf' })
        // 建立預覽 URL
        self.pdfUrl = window.URL.createObjectURL(self.pdfBlob)
        // 開 dialog
        self.pdfDialog = true
      }).catch((error) => {
        console.error('Export PDF error:', error)
        alert(self.$t('__exportPdfError'))
      })
    },
    downloadPdf() {
      if (!this.pdfBlob) return

      const link = document.createElement('a')
      const url = window.URL.createObjectURL(this.pdfBlob)

      link.href = url
      link.download = 'ServiceReport_' + this.caseId + '.pdf'
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
  }
}
</script>